var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 46,
    viewBox: "0 0 59 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5913 22.1477L3.04684 6.8537C5.42063 3.03759 9.68745 0.483154 14.4951 0.483154H44.5432C49.3509 0.483154 53.5877 3.00752 55.9915 6.82362L34.5071 22.0875C31.4722 24.1008 27.566 24.1008 24.5913 22.1477ZM58.0047 12.8032L37.9326 27.0459C35.3485 28.7587 32.4038 29.5996 29.4891 29.5996C26.6045 29.5996 23.7198 28.7587 21.1958 27.076L1.03367 12.8032C1.00362 13.1938 0.973511 13.6142 0.973511 14.0048V32.0336C0.973511 39.4856 7.04322 45.5553 14.4951 45.5553H44.5432C51.9951 45.5553 58.0649 39.4856 58.0649 32.0336V14.0048C58.0649 13.6142 58.0347 13.1938 58.0047 12.8032Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeWhite);
export default __webpack_public_path__ + "static/media/envelope-white.ab9bf0d2c238581538617c7fd2994a1a.svg";
export { ForwardRef as ReactComponent };